{
  "title": "Reality Capture (local)",
  "url": "http://localhost:3000/index.html",
  "description": "Publish, visualize and catalogue Reality Capture data",
  "configCommand": "config_command",
  "enabled": true
}
